<template>
    <div v-if="isLoading" class="mb-5">
        <font-awesome-icon icon="spinner" spin/>
    </div>
    <div v-else>
        <div v-for="group in groups" class="mt-3 mb-5" v-if="refundRequestsGrouped[group.identifier]">
            <h4 class="mb-4">{{ group.display_name }}</h4>

            <refund-request v-for="refundRequest in refundRequestsGrouped[group.identifier]" :refund-request="refundRequest"
                            @changed="changed" :key="refundRequest.id"
            />
        </div>
        <div v-if="refundRequestsGrouped['other']">
            <h4 class="mb-4">Overige</h4>

            <refund-request v-for="refundRequest in refundRequestsGrouped['other']" :refund-request="refundRequest"
                            @changed="changed" :key="refundRequest.id"
            />
        </div>
        <div v-if="!refundRequests.length" class="alert alert-info">
            Geen crediteringen voor deze order
        </div>
    </div>
</template>

<script>
import _ from "lodash"
import RefundRequest from "./components/RefundRequest";

export const STATUSES_CREATED = [
    'created-by-oms',
    'created-by-external-party',
]
export const STATUSES_THAT_REQUIRE_ACTION = [
    'proposal',
    'proposal-to-be-released-automatically',
    'refund-to-be-processed-manually',
    'refund-processing-manually',
]
export const STATUSES_PROCESSING = [
    'refund-to-be-processed',
    'decision-approved-final',
    'refund-processing',
    'refund-error',
]
export const STATUSES_PROCESSED = [
    'decision-denied-final',
    'refunded-externally',
    'refunded',
]

const GROUPS = [
    {
        identifier: 'created',
        display_name: 'In voorverwerking',
        test: refundRequest => STATUSES_CREATED.indexOf(refundRequest.status) !== -1,
    },
    {
        identifier: 'action-required',
        display_name: 'Actie vereist',
        test: refundRequest => STATUSES_THAT_REQUIRE_ACTION.indexOf(refundRequest.status) !== -1,
    },
    {
        identifier: 'processing',
        display_name: 'In verwerking',
        test: refundRequest => STATUSES_PROCESSING.indexOf(refundRequest.status) !== -1,
    },
    {
        identifier: 'processed',
        display_name: 'Volledig verwerkt',
        test: refundRequest => STATUSES_PROCESSED.indexOf(refundRequest.status) !== -1,
    },
]


export default {
    name: "Refunds",
    components: {RefundRequest},
    props: {
        salesOrder: {required: true}
    },

    data() {
        return {
            isLoading: true,
            refundRequests: [],
        }
    },

    computed: {
        groups() {
            return GROUPS
        },
        refundRequestsGrouped() {
            let grouped = _.groupBy(this.refundRequests, r => {
                for (let i in GROUPS) {
                    if (GROUPS[i].test(r)) {
                        return GROUPS[i].identifier
                    }
                }

                return 'other'
            })

            return _.mapValues(grouped, rrqs => _.orderBy(rrqs, ['created_at'], ['desc']))

        },
    },

    mounted() {
        this.getRefundRequests()
    },

    methods: {
        getRefundRequests() {
            const relations = [
                'current_refund_requests.refund_request_lines.refund_request_line_additions',
                'current_refund_requests.refund_request_lines.dispatch_request_line.sales_order_line',
                'current_refund_requests.refund_request_additions',
                'current_refund_requests.dispatch_request:id,status',
                'current_refund_requests.refund_method:id,display_name',
                'current_refund_requests.sales_order:id,grand_total',
            ]

            this.$http.get(`/api/rest/sales-orders/${this.salesOrder.identifier}?include=${relations.join(';')}`)
                .then(response => {
                    this.refundRequests = response.data.current_refund_requests
                    this.isLoading = false
                })
        },
        changed() {
            this.getRefundRequests()
        },
    },
}
</script>

<style scoped lang="scss">
.refundRequest {
    h4 {
        margin-bottom: 0;

        > small {
            font-size: 1rem;
        }
    }
}
</style>
